<template>
  <div class="row align-items-center">
    <div class="col-12 col-md-6">
      <div class="input-group">
        <label class="input-group-text" for="date_filter_select">Período</label>
        <Select
          id="date_filter_select"
          ref="date-filter-select"
          @change="handleDateChange"
          :options="dateOptions"
          v-model="model"
        />
      </div>
    </div>
    <div class="col-12 col-md-6">
      <DateRange
        @onDateChange="handleDateRangeChange"
        :range="range"
        :clearable="clearable"
        id="date_filter_range_input"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { DateFilter, DateFiltersEnum, SelectOption } from "@/@types";
import { DateFilterOptions, dateRanges } from "@/utils";
import moment from "moment";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

const emits = defineEmits(["onChangeDate"]);

const { options = DateFilterOptions, clearable = true } = defineProps<{
  options?: SelectOption[];
  clearable?: boolean;
}>();

const range = ref();
const model = ref();
const dateOptions = ref<SelectOption[]>(options);
const route = useRoute();

onMounted(() => {
  updateRange(route.query);
});

watch(route, (newRoute) => {
  updateRange(newRoute.query);
});

const updateRange = (query: any) => {
  if (query.date_start && query.date_end) {
    range.value = {
      date_start: moment(query.date_start),
      date_end: moment(query.date_end),
    };
  }
  updateOptions();
};

const updateOptions = () => {
  let value = "";

  const format = "YYYY-MM-DD";
  const startDate = range?.value?.date_start
    ? moment(range?.value?.date_start).format(format)
    : null;
  const endDate = range?.value?.date_end
    ? moment(range?.value?.date_end).format(format)
    : null;
  const todayDate = moment().format(format);
  const startOfMonth = moment().startOf("month").format(format);
  const endOfMonth = moment().endOf("month").format(format);

  const isToday = startDate === todayDate && endDate === todayDate;
  const isThisMonth = startDate === startOfMonth && endDate === endOfMonth;
  const isAll = !startDate && !endDate;

  if (isToday) value = DateFiltersEnum.today;
  if (isThisMonth) value = DateFiltersEnum.current_month;
  if (isAll) value = DateFiltersEnum.all;

  model.value = value;

  dateOptions.value = options.map((elem) => ({
    ...elem,
    selected: elem?.value === value,
  }));
};

const handleDateChange = (event: any, type: string) => {
  const value = event.target?.value;
  const dateRange = dateRanges[value as DateFilter];
  if (dateRange.date_start && dateRange.date_end) {
    range.value = dateRange;
  }
  range.value = null;
  emits("onChangeDate", range?.value);
};

const handleDateRangeChange = (value: any) => {
  range.value = value;
  updateOptions();
  emits("onChangeDate", range?.value);
};
</script>
